import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import { useReportGuide } from '../../hooks/useReportGuide';

type ReportGuideMenuProps = {
  anchorEl: HTMLButtonElement | null;
};

const ReportGuideMenu: React.FC<ReportGuideMenuProps> = ({ anchorEl }) => {
  const { selectedGuide, setSelectedGuide, setAnchorEl } = useReportGuide();

  function onClose() {
    setSelectedGuide(null);
    setAnchorEl(null);
  }

  function handlePrint() {
    window.open(`/guides/${selectedGuide?.id}/print`, '_blank');
    onClose();
  }

  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
      <MenuItem onClick={handlePrint}>Imprimir guia</MenuItem>
    </Menu>
  );
};

export default ReportGuideMenu;
